import { useContext } from "react";

import { DialogContext, ErrorOptions, SuccessOptions } from "@/shared/contexts/dialogContext";

export const useDialog = (): {
    errorDialog: (options: ErrorOptions) => Promise<void>;
    successDialog: (options: SuccessOptions) => Promise<void>;
} => {
    const { errorDialog, successDialog } = useContext(DialogContext);

    return {
        errorDialog,
        successDialog,
    };
};
